// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- WIP */

.ComboboxOption-module__Container__mAkRJ {
    display: flex;
    gap: var(--ds-m);
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-s);
    padding-left: var(--ds-sm);
    border-radius: var(--ds-border-radius-s);
    cursor: pointer;
    transition: background-color var(--ds-transition-s) ease-in-out;
}

.ComboboxOption-module__Disabled__hDT0V {
    cursor: auto;
}

.ComboboxOption-module__Selected__fzkNE {
    background-color: var(--ds-interaction-select);
}

.ComboboxOption-module__Current__pzfdL {
    background-color: var(--ds-interaction-hover);
}

.ComboboxOption-module__Container__mAkRJ:hover {
    background-color: var(--ds-interaction-hover);
}

.ComboboxOption-module__Content__WXWtZ {
    display: flex;
    gap: var(--ds-gap-s);
    align-items: center;
    min-width: 0;
    line-height: var(--ds-line-height-big);
}

.ComboboxOption-module__FlexFix__pQ5Uu > * {
    min-width: 0;
}

.ComboboxOption-module__Checkbox__u3JOf {
    display: flex;
}

.ComboboxOption-module__Text__BYC7w {
    line-height: var(--ds-5x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ComboboxOption-module__Container__mAkRJ`,
	"Disabled": `ComboboxOption-module__Disabled__hDT0V`,
	"Selected": `ComboboxOption-module__Selected__fzkNE`,
	"Current": `ComboboxOption-module__Current__pzfdL`,
	"Content": `ComboboxOption-module__Content__WXWtZ`,
	"FlexFix": `ComboboxOption-module__FlexFix__pQ5Uu`,
	"Checkbox": `ComboboxOption-module__Checkbox__u3JOf`,
	"Text": `ComboboxOption-module__Text__BYC7w`
};
export default ___CSS_LOADER_EXPORT___;
